<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="OK()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [modalHelpIndex]="modalHelpIndex"
    [(isBusyMessage)]="isBusyMessage" [modalClass]="modalClass">
    <res-name-description [automationId]="modalAutomationId" [validateName]="true"
        [validateNameRequest]="validateNameRequest" [tooltipName]="tooltipName"></res-name-description>
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label for="block-content" requiredAsterisk>Content:
            </label>
        </div>
        <div class="modal-row-column-max description">
            <textarea id="description" class="excludedContentTextArea" [(ngModel)]="blockContent"
                [attr.data-automation-id]="modalAutomationId + '-content-input'" name="description"
                maxLength="500"></textarea>
        </div>
    </div>
</res-base-modal>